import api from "./api";

const hallTicketService = {
  configureHallTicket: (examId, payload) =>
    api.post(`/hall-ticket/${examId}/configure`, payload),

  getHallTicketConfig: (examId) => api.get(`/hall-ticket/${examId}/config`),

  generateHallTickets: (examId) => api.post(`/hall-ticket/${examId}/generate`),

  publishHallTickets: (examId) => api.post(`/hall-ticket/${examId}/publish`),

  unpublishHallTickets: (examId) =>
    api.post(`/hall-ticket/${examId}/unpublish`),

  listHallTicketRecords: (examId) => api.get(`/hall-ticket/${examId}/records`),

  // Staff PDF preview: resolve a short-lived signed URL for a single record.
  getRecordPdfUrl: (examId, recordId) =>
    api.get(`/hall-ticket/${examId}/records/${recordId}/pdf`),
};

export default hallTicketService;
